const RolePermission = {    
    install(Vue) {
        Vue.mixin({          
            directives: {                
                rolePermission: {                
                    inserted: function (el, payLoad, vnode) {
                        let appState = vnode.context.$store.state;
                        let user = appState.auth.user;   
                        let isShow = false; 
                        for (let resource=0; resource < payLoad.value.resources.length; resource++) {
                            let resourceLowerCase = payLoad.value.resources[resource].toLowerCase()
                            let rolePermissionData = appState.rolePermissions.rolePermissionData;
                            let permissionDatafilteredArray = rolePermissionData.filter(r=> r.resource.toLowerCase() == resourceLowerCase);
                            let permissionDataItem = (permissionDatafilteredArray && permissionDatafilteredArray.length > 0) 
                            ? permissionDatafilteredArray[0] : null;
                            for (let element=0; element < payLoad.value.elements.length; element++) {
                                let elementName = payLoad.value.elements[element];
                                if(permissionDataItem && permissionDataItem.subResource) {
                                let filteredArray = permissionDataItem.subResource.filter(r=> r.elements.some(element => element == elementName));
                                if(filteredArray && filteredArray.length > 0) {
                                    for(let i = 0; i < filteredArray.length; i++) {
                                        let item = filteredArray[i];
                                        let roleFilteredArray = user.roles.filter(roleObj => (item.roles.indexOf(roleObj.displayName) > -1));
                                        if(roleFilteredArray && roleFilteredArray.length > 0) {
                                            if(!item.claims || item.claims.length == 0) { // no claims available to hide this element
                                                isShow = true;
                                            } else {
                                                if(user.partnerID && user.partnerID > 0) {
                                                    isShow = true;
                                                }
                                            }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        el.style.display = (isShow) ? 'block' : 'none';
                    }
                }
            },
      });
    }    
  };

  export default RolePermission;